import { Action, NestedListState } from "./types";

const nestedItemsReducer = (state: NestedListState, action: Action) => {
    switch(action.type){
        case "SET_FIRST":
            return {...state, first: action.payload};
        case "SET_SECOND":
            return {...state, second: action.payload};
        case "SET_THIRD":
            return {...state, third: action.payload};
        default:
            return state;
    }
}

export default nestedItemsReducer;